// Host elements that join an installed app entity's palette group, beside the
// generic elements minted from that entity's fields (e.g. the call elements on
// Chat's Conversation). Pure CommonJS so the node unit suite can require it.

function appEntityExtensionKey(entityConfig) {
  if (!entityConfig?.appName || entityConfig.isLegacyEntity || !entityConfig.entityType) {
    return null;
  }

  return `${entityConfig.appName}.${String(entityConfig.entityType).split(".").at(-1)}`;
}

// Each component stays `hidden: true` in its static registration (so it only
// resolves there); the entry listed under a context is the visible one, bound
// to that context and its type so a rebind offers only same-type contexts.
function toExtensionPaletteEntries(components, contextName, entityConfig) {
  const entityType = String(entityConfig.entityType).split(".").at(-1);

  return components.map(component => {
    const displayName = component.elementPanelSettings?.displayName ?? component.name;

    return {
      ...component,
      displayName,
      elementPanelSettings: {
        ...component.elementPanelSettings,
        displayName,
      },
      context: {
        appName: entityConfig.appName,
        entityContext: contextName,
        entityType,
      },
      hidden: false,
    };
  });
}

function withExtensionEntries(genericElements, extensionEntries) {
  const seen = new Set();
  const extensions = extensionEntries.filter(entry => {
    if (seen.has(entry.name)) {
      return false;
    }
    seen.add(entry.name);

    return true;
  });

  return [...genericElements, ...extensions];
}

module.exports = {
  appEntityExtensionKey,
  toExtensionPaletteEntries,
  withExtensionEntries,
};
